import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './components/admin/landing/landing.component';
import { MemberListComponent } from './components/admin/member-list/member-list.component';
import { ChooseLangComponent } from './components/choose-lang/choose-lang.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { SuccessComponent } from './components/success/success.component';

const routes: Routes = [
  { path: 'register', component: RegistrationComponent },
  { path: 'success', component: SuccessComponent },
  { path: 'admin/zbulnt/44822', component: LandingComponent },
  { path: 'admin/zbulnt/44822/member-list', component: MemberListComponent },
  
  { path: '*', component: ChooseLangComponent },
  { path: '', component: ChooseLangComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
